import React, { useEffect, useState } from 'react';
import { string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { NamedLink } from '../../components';
import hand from './image/hand.png';
import css from './SectionHero.module.css';
import { connect, useDispatch } from 'react-redux';
import { P } from '../../containers/PageBuilder/Primitives/P';

const SectionHero = props => {
  const [mounted, setMounted] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const { rootClassName = null, className = null, currentUser } = props;
  const userType = currentUser?.attributes?.profile?.privateData?.userTypes;
  const isUserProvider = userType?.includes('communicationProfessional');
  const dispatch = useDispatch();

  useEffect(() => {
    setMounted(true);
  }, []);

  const classes = classNames(rootClassName || css.root, className);
  const isAuthenticated = !!currentUser?.id;
  const notCustomer = ['deafUser', 'communicationProfessional'];
  const viewBookingsOnly =
    userType && notCustomer.some(a => userType.includes(a)) && !userType.includes('customer');
  return (
    <div className={classes}>
      <div className={css.heroContent}>
        <div>
          <h1 className={css.heroMainTitle}>
            <FormattedMessage id="SectionHero.investHero" />
            {/* <FormattedMessage id="SectionHero.title" /> */}
          </h1>
          <h2 className={css.heroSubTitle}>
            <FormattedMessage id="SectionHero.subTitle" />
          </h2>
          <div className={css.callsToAction}>
            <NamedLink
              name="SearchPage"
              to={{
                search:
                  'address=Merseyside%2C%20England%2C%20United%20Kingdom&bounds=54.74975971%2C-0.99274902%2C52.27799597%2C-4.15681152&pub_listingtype=listing',
              }}
              className={css.heroButtonSecondary}
            >
              <FormattedMessage id="SectionHero.browseButton" />
            </NamedLink>
            {
              // isAuthenticated && isUserProvider ? (
              //   <NamedLink
              //     name="SearchPage"
              //     to={{
              //       search: 'pub_listingtype=requirement',
              //     }}
              //     className={css.heroButton}
              //   >
              //     <FormattedMessage id="SectionHero.browseBookingsButton" />
              //   </NamedLink>
              // ) :
              // !viewBookingsOnly ? (
              //   <NamedLink className={css.heroButton} name="CreateRequirementPage">
              //     <FormattedMessage id="TopbarDesktop.createRequirementListing" />
              //   </NamedLink>
              // ) : null
            }
            <NamedLink name="CMSPage" params={{ pageId: 'invest' }} className={css.heroButton}>
              <FormattedMessage id="TopbarDesktop.toInvestPage" />
            </NamedLink>
          </div>
        </div>
        <img fetchpriority="high" src={hand} alt="Signalise hand" className={css.heroHand} />
      </div>
    </div>
  );
};

SectionHero.propTypes = {
  rootClassName: string,
  className: string,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    currentUser,
  };
};

export default connect(mapStateToProps)(SectionHero);
